import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";

const ButtonNext = (props) => {
  const {
    text,
    onClick,
    hidden,
    disabled,
    faicon,
    isLoading,
    variant,
    className,
  } = props;

  return (
    <>
      <Button
        variant={variant}
        className={className}
        disabled={disabled || isLoading}
        onClick={onClick}
        hidden={hidden}
      >
        {isLoading ? (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <FontAwesomeIcon icon={faicon} className="me-2" />
        )}
        {text}
      </Button>
    </>
  );
};

export default ButtonNext;
